import { C6_PRODUCT_CARD_CHOICE } from '../cross-selling-modal/cross-selling-products-layout';

const DEFAULT_PAGE_SIZE = 3;
const C6_PAGE_SIZE = 2;

export interface BogofDesktopProductsLayout {
  pageSize: number;
  rowClass: string;
  cardClass: string;
}

export function bogofDesktopPageSize(
  productCardChoice: number | string | null | undefined,
): number {
  return Number(productCardChoice) === C6_PRODUCT_CARD_CHOICE ? C6_PAGE_SIZE : DEFAULT_PAGE_SIZE;
}

export function resolveBogofDesktopProductsLayout(input: {
  displayedCount: number;
  productCardChoice: number | string | null | undefined;
}): BogofDesktopProductsLayout {
  const isC6Layout = Number(input.productCardChoice) === C6_PRODUCT_CARD_CHOICE;
  const pageSize = bogofDesktopPageSize(input.productCardChoice);

  if (isC6Layout) {
    if (input.displayedCount <= 1) {
      return {
        pageSize,
        rowClass: 'flex max-w-[365px] items-stretch justify-center gap-5',
        cardClass: 'mx-auto flex w-full min-w-0 max-w-[365px] flex-col',
      };
    }

    return {
      pageSize,
      rowClass: 'flex w-full items-stretch justify-center gap-5',
      cardClass: 'flex min-w-0 flex-1 flex-col',
    };
  }

  if (input.displayedCount <= 1) {
    return {
      pageSize,
      rowClass: 'flex max-w-[340px] items-stretch justify-center gap-2',
      cardClass: 'flex w-[320px] flex-col',
    };
  }

  if (input.displayedCount === 2) {
    return {
      pageSize,
      rowClass: 'flex max-w-[700px] items-stretch justify-evenly gap-2',
      cardClass: 'flex w-[280px] flex-col',
    };
  }

  return {
    pageSize,
    rowClass: 'flex w-full items-stretch justify-between gap-2',
    cardClass: 'flex w-[240px] flex-col',
  };
}
